import { Table } from '@statsbomb/kitbag-components';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  getEventsLastUpdated,
  getMatchDateAndTime,
  getMatchName,
} from '../../utils/alignment-data';
import getOffsetRequiredHeadingCells from '../../pages/offsetRequired.helper';
import { videoInfoPropTypes } from '../../types/videoInfo';
import { videoReferencePropTypes } from '../../types/videoReference';
import { EMPTY_CELL_VALUE } from '../../constants/tableRows';
import { ReviewOffsetsButton } from '../VideoAlignmentCheck/steps/ReviewOffsetsButton';

export function OffsetRequiredTableRows({ streams }) {
  const intl = useIntl();
  const headingCells = useMemo(
    () => getOffsetRequiredHeadingCells(intl),
    [intl],
  );

  return streams?.length > 0 ? (
    streams.map(({ videoReference, videoInfo }) => (
      <Table.Row
        key={`offset-required-${JSON.stringify({
          videoReference,
        })}`}
      >
        <Table.DataCell>{getMatchName(videoInfo, intl)}</Table.DataCell>
        <Table.DataCell>
          {videoReference?.matchId || EMPTY_CELL_VALUE}
        </Table.DataCell>
        <Table.DataCell>
          {videoReference?.period || EMPTY_CELL_VALUE}
        </Table.DataCell>
        <Table.DataCell>
          {videoInfo?.competition || EMPTY_CELL_VALUE}
        </Table.DataCell>
        <Table.DataCell>
          {videoInfo?.countryName || EMPTY_CELL_VALUE}
        </Table.DataCell>
        <Table.DataCell>{getMatchDateAndTime(videoInfo, intl)}</Table.DataCell>
        <Table.DataCell>
          {videoReference?.version || EMPTY_CELL_VALUE}
        </Table.DataCell>
        <Table.DataCell>
          <ReviewOffsetsButton
            videoInfo={videoInfo}
            videoReference={videoReference}
          />
        </Table.DataCell>
        <Table.DataCell>
          {getEventsLastUpdated(videoInfo, intl) || EMPTY_CELL_VALUE}
        </Table.DataCell>
      </Table.Row>
    ))
  ) : (
    <Table.Row>
      <Table.DataCell colSpan={headingCells.length}>
        <FormattedMessage
          defaultMessage="No alignment queue events found"
          id="8e882"
        />
      </Table.DataCell>
    </Table.Row>
  );
}

OffsetRequiredTableRows.propTypes = {
  streams: PropTypes.arrayOf(
    PropTypes.shape({
      videoInfo: videoInfoPropTypes.isRequired,
      videoReference: videoReferencePropTypes.isRequired,
    }),
  ),
};

OffsetRequiredTableRows.defaultProps = {
  streams: [],
};

export default { OffsetRequiredTableRows };
